// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */
.clickable {
  cursor: pointer;
  padding: 10px;
  transition: background-color 0.3s ease;
}

.clickable:hover {
  background-color: #e0e0e0; /* Background color on hover */
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/layout/appTopbar.css"],"names":[],"mappings":"AAAA,eAAA;AACA;EACE,eAAA;EACA,aAAA;EACA,sCAAA;AACF;;AAEA;EACE,yBAAA,EAAA,8BAAA;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
